import React, { Dispatch, SetStateAction } from 'react';
import useProfileHeader from './profileHeader-hook';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import { VisitorPageContents } from '../../../../../visitorPage';
import Logo from '../../../../../../../Business/Restaurant/Components/Logo/logo';
import { MenuIcon, SettingIcon } from '../../../../../../../../Components/IconComponents';
import CustomDialog from '../../../../../../../../Components/Dialog/customDialog';
import SettingsDialog from '../../../../../../../../Components/Dialog/DialogContents/UserProfile/Settings/settingsDialog';
import CustomDrawer from '../../../../../../../../Components/Drawer/CustomDrawer/customDrawer';
import HeaderMenuDrawer from '../../Drawer/HeaderMenuDrawer/headerMenuDrawer';
import { IServices } from '../../../../../../../../Interfaces/responseTypes';
import { getSmartBusinessTitle } from '../../../../../../../../Costants/companyNameSubtitleKeywords';
import styles from './profileHeader.module.scss';

export interface IProfleHeaderProps {
    logo: string,
    title: string,
    companyId: number,
    setContentType: Dispatch<SetStateAction<VisitorPageContents>>,
    is_user: boolean,
    services: IServices | null;
    onOpenReserveDialog: () => void
}

const ProfileHeader: React.FC<IProfleHeaderProps> = (props) => {
    const { logo, title, companyId, is_user, services, setContentType } = props;
    const tableReservation = services?.reserve;
    const { baseURL, mediumScreen, mobileScreen } = useNoAuthHooks();
    const { hasSmartSubtitle, mainTitle, subtitle } = getSmartBusinessTitle(title);
    const {
        open,
        openDrawer,
        onOpen,
        onClose,
        onOpenDrawer,
        onCloseDrawer,
        onReserveDialog
    } = useProfileHeader(props);

    return (
        <div className={styles.header}>
            <Logo imageUrl={logo} baseURL={baseURL!} logoStyle={`${styles.logo} ${styles.headerLogo}`} onClick={() => setContentType(VisitorPageContents.MENU)} />
            {
                hasSmartSubtitle
                    ?
                    <div className={mobileScreen ? styles.mobileCenteredTitle : styles.smartCenteredTitle}>
                        <p className={mobileScreen ? styles.mobileTitle : styles.smartTitle}>{mainTitle}</p>
                        <p className={mobileScreen ? styles.mobileSubtitle : styles.smartSubtitle}>{subtitle}</p>
                    </div>
                    :
                    mobileScreen
                        ? (
                            <div className={styles.mobilePlainTitle}>
                                <p className={styles.mobilePlainTitleText}>{title}</p>
                            </div>
                        )
                        : (
                            <p className={`${styles.title} ${title.length > 20 && !mediumScreen ? styles.longTitle : ''}`}>
                                {title}
                            </p>
                        )
            }
            <div className={styles.navBox}>
                {!mobileScreen
                    ?
                    <div className={styles.headerIcon}>
                        <MenuIcon color='var(--icon-color)' width={23} height={23} onClick={onOpenDrawer} />
                    </div>
                    :
                    (
                        services?.reserve
                            ?
                            <div className={styles.headerIcon}>
                                <MenuIcon onClick={onOpenDrawer} color="var(--icon-color)" width={23} height={23} />
                            </div>
                            :
                            <div className={styles.headerIcon}>
                                <SettingIcon onClick={onOpen} color="var(--icon-color)" />
                            </div>
                    )
                }
            </div>

            <CustomDialog
                open={open}
                onClose={onClose}
                children={<SettingsDialog onClose={onClose} />}
            />
            <CustomDrawer
                open={openDrawer}
                onClose={onCloseDrawer}
                children={
                    <HeaderMenuDrawer
                        logo={logo}
                        onClose={onCloseDrawer}
                        active={VisitorPageContents.PROFILE}
                        companyId={companyId}
                        setContentType={setContentType}
                        is_user={is_user}
                        tableReservation={tableReservation}
                        onReserveTableDialog={onReserveDialog}
                    />
                }
            />
        </div>
    )
};

export default ProfileHeader
